// extracted by mini-css-extract-plugin
module.exports = {"dots":"styles_dots__3Kyzy","thinkingLabel":"styles_thinkingLabel__2XjLx","shimmer":"styles_shimmer__3kCCG","dot":"styles_dot__2SZoV"};